import CreateDocumentButton from './CreateDocumentButton'

export default CreateDocumentButton
